export default __webpack_public_path__ + "static/media/LabReceiveDbsl.6d233f8e.svg";